export default {
    props: {
        links: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            applicationLinks: null
        };
    },
    provide() {
        this.applicationLinks = {
            links: this.links,
            get: function (link) {
                return  this.links[link];
            }
        };

        return {
            applicationLinks: this.applicationLinks
        };
    }
};
